export const CONTACT_TYPE_PLAINTIFF_ATTORNEY = 1;
export const CONTACT_TYPE_DEFENSE_ATTORNEY = 2;
export const CONTACT_TYPE_TREATING_PROVIDER = 3;
export const CONTACT_TYPE_REFERRAL_SOURCE = 4;
export const CONTACT_TYPE_INSURANCE_ATTORNEY = 5;
export const CONTACT_TYPE_INSURANCE_CARRIER = 6;
export const CONTACT_TYPE_HOSPITAL = 7;
export const CONTACT_TYPE_EMPLOYER = 8;
